// Sidemenu.tsx - VERSIÓN FINAL BASADA EN TU CÓDIGO FUNCIONAL
import * as React from "react";
import { useRef } from "react";
import { motion, useCycle } from "framer-motion";
import { useDimensions } from "./use-dimensions.tsx";
import { MenuToggle } from "./MenuToggle.tsx";
import { Navigation } from "./Navigation.tsx";

const sidebar = {
  open: (height = 300) => ({
    clipPath: `circle(${height * 2 + 200}px at 40px 40px)`,
    transition: {
      type: "spring",
      stiffness: 20,
      restDelta: 2
    }
  }),
  closed: {
    clipPath: "circle(30px at 40px 40px)",
    transition: {
      delay: 0.5,
      type: "spring",
      stiffness: 400,
      damping: 40
    }
  }
};

export const Sidemenu = ({ SignOut, username }) => {
  const [isOpen, toggleOpen] = useCycle(false, true);
  const containerRef = useRef(null);
  const { height } = useDimensions(containerRef);

  return (
    <motion.nav
      initial={false}
      animate={isOpen ? "open" : "closed"}
      custom={height}
      ref={containerRef}
    >
      <motion.div
        className="background"
        style={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          bottom: 0,
          width: '280px', 
          zIndex: 50,
          background: '#fff',
          boxShadow: '0 10px 30px rgba(0,0,0,.12)',
          borderRight: '1px solid rgba(0,0,0,.06)'
        }}
        variants={sidebar}
      >
        <MenuToggle toggle={() => toggleOpen()} isOpen={isOpen} />
        <Navigation SignOut={SignOut} username={username} />
      </motion.div>

      {/* Backdrop para cerrar al hacer clic fuera */}
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 40
          }}
          onClick={() => toggleOpen()}
        />
      )}
    </motion.nav>
  );
};